import { ComponentPropsWithoutRef } from 'react';

export const MixedBlocksIcon = ({
  ...props
}: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 31 30" fill="none">
      <path
        d="M3.833 6.667a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Zm23.334 0a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667Zm3.333 20a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0ZM3.833 30a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667ZM8.765 4.167a5 5 0 0 0-.217-2.5h7.785A4.167 4.167 0 0 1 20.5 5.833V10h4.167a4.167 4.167 0 0 1 4.166 4.167v7.783a5 5 0 0 0-2.5-.215v-7.568a1.667 1.667 0 0 0-1.666-1.667H20.5v3.333A4.167 4.167 0 0 1 16.333 20H13v4.167a1.667 1.667 0 0 0 1.667 1.666h7.568a5 5 0 0 0 .217 2.5h-7.785a4.167 4.167 0 0 1-4.167-4.166V20H6.333a4.167 4.167 0 0 1-4.166-4.167V8.05a5 5 0 0 0 2.5.215v7.568A1.666 1.666 0 0 0 6.333 17.5H10.5v-3.333A4.167 4.167 0 0 1 14.667 10H18V5.833a1.667 1.667 0 0 0-1.667-1.666H8.765ZM16.333 17.5A1.666 1.666 0 0 0 18 15.833V12.5h-3.333A1.666 1.666 0 0 0 13 14.167V17.5h3.333Z"
        fill="#000000"
      />
    </svg>
  );
};
